import script from "./AgentsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentsList.vue?vue&type=script&lang=ts&setup=true"

import "./AgentsList.vue?vue&type=style&index=0&id=c70150dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c70150dc"]])

export default __exports__